<template>
  <div>
  <Slider :icon="'history'" :width="481" :style="{zIndex: 999}"
  label="銷項紀錄" defaultClass="editSheet"
  :show="!!item"
  @close="$emit('close')">
  <div class="flexH">
    <RT :options="['交易資訊', '發票資訊']" :defaultValue="page" @input="page=$event" :style="{display:'flex', flexDirection:'row'}"></RT>
    <template v-if="item&&page==='發票資訊'">
    <RT :options="item.inv.map(e => e.InvoiceNo)" :defaultValue="InvoiceNo" @input="InvoiceNo=$event" :style="{display:'flex', flexDirection:'row'}"></RT>
    <SliderInfoBtns :btnHide="true" v-if="item">
      <div class="field">
        <div>交易型態</div>
        <div :style="{color: `var(--${inv.status})`, fontSize: '24px', fontWeight: 700}">{{
          item.status === '已取消' ? inv ? inv.status : '交易取消' : '銷售'
        }}</div>
      </div>
      <div class="field">
        <div>發票號碼</div>
        <div>
          <div v-for="iv in item.inv" :key="`iv-${iv.InvoiceNo}`"
          :style="[iv.status === '作廢' ? {textDecoration: 'line-through'} : {}]">{{iv.InvoiceNo}}</div>
        </div>
      </div>
      <div class="field">
        <div>交易時間</div>
        <div>{{moment(item.paidTime).format('yyyy/MM/DD HH:mm')}}</div>
      </div>
      <div class="field">
        <div>交易序號</div>
        <div>{{(item.serialNoCashier||item.serialNo).toString().padStart(4, 0)}}</div>
      </div>
      <div class="field">
        <div>區域</div>
        <div>{{item.store}}</div>
      </div>
      <div class="field">
        <div>機號</div>
        <div>{{item.cashierMachine}}</div>
      </div>
      <hr>
      <div class="field2" :style="{}">
        <div>操作人員: {{item.operator?item.operator?.name:item.createBy?.name}}</div>
        <div>{{item.updateTime ? moment(item.updateTime).format('YYYY/MM/DD HH:mm') : null}}</div>
      </div>
    </SliderInfoBtns>
    <SliderInfoBtnsT2  v-if="item&&inv&&InvoiceNo" :title="'發票資訊'" :style="{height: 'fit-content'}" :btnHide="true">
      <div class="field">
        <div>機號</div>
        <div>{{inv.MachineID}}</div>
      </div>
      <div class="field">
        <div>開立時間</div>
        <div>{{moment(inv.InvoiceDate).format('yyyy-MM-DD HH:mm:ss')}}</div>
      </div>
      <div class="field">
        <div>開立狀態</div>
        <div>{{inv?.status||'開立'}}</div>
      </div>
      <div class="field">
        <div>開立方式</div>
        <div v-if="inv.CustomerIdentifier">統編發票 {{inv.CustomerIdentifier}}</div>
        <div v-else-if="parseInt(inv.Print)">紙本發票</div>
        <div v-else-if="inv.CarrierType && inv.CarrierNum">電子發票 {{inv.CarrierNum}}</div>
        <div v-else-if="parseInt(inv.Donation) && inv.LoveCode">捐贈發票 {{inv.LoveCode}}</div>
      </div>
      <div class="field">
        <div>上傳狀態</div>
        <div>{{inv.isUpload ? '已上傳':'未上傳'}}</div>
      </div>
      <div class="field" v-if="inv.status === '作廢'">
        <div>作廢原因</div>
        <div>{{inv.Reason||'-'}}</div>
      </div>
      <hr>
      <div class="field2" :style="{}" v-for="(RMsg, r) in inv.ReturnMsg" :key="`returnMsg-${r}`">
        <div>[{{RMsg.Status}}][{{RMsg.code}}] {{RMsg.Msg}}</div>
        <div>{{RMsg.time ? moment(RMsg.time).format('YYYY/MM/DD HH:mm') : null}}</div>
      </div>
    </SliderInfoBtnsT2>
    <SliderInfoBtnsT2  v-if="item&&inv" :title="'發票明細'"
    :edit="editOrder" @edit="editOrder=true">
    <template  v-for="(itm, i) in inv.Items">
      <hr class="orders" v-if="i!==0" :key="`hr-${i}`">
      <OrderCardInv :key="`card-${i}`" :item="itm"/>
    </template>
    <hr>
    <div class="field3" :style="{}">
      <div></div>
      <div>
        <div>發票總額</div>
        <div>{{inv.SalesAmount}}</div>
      </div>
    </div>
    </SliderInfoBtnsT2>
    <SliderInfoBtnsT2  v-if="inv?.status!=='作廢'" :title="'作廢發票'" :style="{height: 'fit-content'}" :btnHide="true">
    <div :style="{width: '100%', display: 'flex', flexDirection: 'column', gap: '15px'}">
      <SqrBtn v-if="item.inv" @click="TEXT='確定要取消交易嗎?'" :style="{height: '50px', fontSize: '20px'}" :text="'作廢發票'" :bg="'var(--color-checked)'"/>
      <SqrBtn v-else @click="TEXT='確定要取消交易嗎?'" :style="{height: '50px', fontSize: '20px'}" :text="'取消訂單'" :bg="'var(--color-checked)'"/>
      <!-- <SqrBtn v-if="item.inv" :style="{height: '50px', fontSize: '20px', color: 'var(--color-pri)'}"
      :text="'整張折讓'" :bg="'var(--color-bar)'"/> -->
    </div>
    </SliderInfoBtnsT2>
    </template>
    <template v-else-if="item&&page==='交易資訊'">
      <SliderInfoBtns :btnHide="true">
        <div class="field">
          <div>類型</div>
          <div :style="{color: `var(--${item.type})`, fontSize: '24px', fontWeight: 700}">{{item.type}}</div>
        </div>
        <div class="field" v-if="item.project">
          <div>專案</div>
          <div>{{item.project}}</div>
        </div>
        <div class="field">
          <div>時間</div>
          <div>{{moment(item.visitDate).format('yyyy/MM/DD')}} {{item.visitTime}}</div>
        </div>
        <div class="field">
          <div>消費者</div>
          <div>{{item.orderer||'-'}}</div>
        </div>
        <div class="field">
          <div>電話</div>
          <div>{{item.ordererTel||'-'}}</div>
        </div>
        <template v-if="item.type==='自取'">
        <div class="field" >
          <div>取件人</div>
          <div>{{item.recipient||'-'}}</div>
        </div>
        <div class="field">
          <div>電話</div>
          <div>{{item.recipientTel||'-'}}</div>
        </div>
        </template>
        <template v-else-if="item.type==='宅配'">
        <div class="field" >
          <div>收件人</div>
          <div>{{item.recipient||'-'}}</div>
        </div>
        <div class="field">
          <div>電話</div>
          <div>{{item.recipientTel||'-'}}</div>
        </div>
        <div class="field">
          <div>地址</div>
          <div>{{item.address}}</div>
        </div>
        </template>

        <hr>
        <div class="field2" :style="{}" v-if="item.operator||item.createBy">
          <div>操作人員: {{item.operator?item.operator?.name:item.createBy?.name}}</div>
          <div>{{item.updateTime ? moment(item.updateTime).format('YYYY/MM/DD HH:mm') : null}}</div>
        </div>
      </SliderInfoBtns>
      <SliderInfoBtnsT2 :title="'取消付款資訊'" v-if="item.CancelInfo" :style="{height: 'fit-content'}" :btnHide="true">
        <div class="field">
          <div>付款方式</div>
          <div>{{item.CancelInfo?.ECR_Response_Code&&'信用卡' || item.CancelInfo?.Response_Code&&'電子支付'}}</div>
        </div>
        <!-- <div class="field" v-if="item.orderId&&item.payInfo">
          <div>付款編號</div>
          <div>{{item.orderId}}</div>
        </div> -->
        <template v-if="item.CancelInfo?.ECR_Response_Code">
          <hr>
          <div class="field">
            <div>卡號</div>
            <div>{{item.CancelInfo.Card_No}}</div>
          </div>
          <div class="field">
            <div>授權碼</div>
            <div>{{item.CancelInfo.Approval_No}}</div>
          </div>
          <div class="field" v-if="item.CancelInfo.Trans_Date">
            <div>授權時間</div>
            <div>{{moment(item.CancelInfo.Trans_Date+item.CancelInfo.Trans_Time, 'GGMMDDHHmmss').format('YYYY/MM/DD HH:mm:ss')}}</div>
          </div>
          <div class="field">
            <div>卡別</div>
            <div>{{getCreditType(item.CancelInfo.Card_Type)}}</div>
          </div>
          <hr>
        </template>
        <template v-if="item.CancelInfo?.Response_Code">
          <hr>
          <div class="field">
            <div>交易類型</div>
            <div>{{item.CancelInfo.Trans_Type === '11' ? '銷售' : '退貨'}}</div>
          </div>
          <div class="field" v-if="item.CancelInfo.Trans_Date">
            <div>授權時間</div>
            <div>{{moment(item.CancelInfo.Txn_Date+item.CancelInfo.Txn_Time, 'YYYYMMDDHHmmss').format('YYYY/MM/DD HH:mm:ss')}}</div>
          </div>
          <div class="field">
            <div>訂單編號</div>
            <div>{{item.CancelInfo.Order_Id}}</div>
          </div>
          <div class="field">
            <div>電子錢包</div>
            <div>{{getPayway(item.CancelInfo.Wallet)}}</div>
          </div>
          <hr>
        </template>
        <div class="field" v-if="item.payInfo">
          <div>支付金額</div>
          <div>{{formatDollarInt(parseInt(item.payInfo.Trans_Amount)/(item.payInfo?.ECR_Response_Code ? 100 : 1))}}</div>
        </div>
        <template v-if="item.cash">
          <div class="field">
            <div>現金</div>
            <div>{{item.cash}}</div>
          </div>
          <div class="field">
            <div>找零</div>
            <div>{{item.cashreturn}}</div>
          </div>
        </template>
        <div class="field" v-for="(vc, v) in item.voucherCashInfo" :key="`vc-${v}`">
          <div>{{vc.name}}</div>
          <div>{{vc.Trans_Amount}}</div>
        </div>
        <div class="field" v-if="item.balance">
          <div>點數折抵</div>
          <div>{{item.balance}}</div>
        </div>
      </SliderInfoBtnsT2>
      <SliderInfoBtnsT2 :title="'付款資訊'" :style="{height: 'fit-content'}" :btnHide="true">

        <remitVue v-if="item.remit" :item="item.remit" :remitType="item.remitType" :remitTime="item.remitTime" :other="{remit5code: item.remit5code, remitName: item.remitName}"/>
        <remitInfoVue v-else-if="item.remitInfo" :id="item._id" :item="item.remitInfo" :remitTime="item.remitTime||item.reconciledTime"
        :other="{remit5code: item.remit5code, remitName: item.remitName}" @cancelEc="cancelEc=$event" @cancelLine="cancelLine=$event"/>
        <hr v-if="item.remit||item.remitInfo">
        <div class="field">
          <div>付款方式</div>
          <div>{{[
            (item.payInfo?.ECR_Response_Code&&'信用卡' || item.payInfo?.Response_Code&&'電子支付' || (item.price>0?'現金':'')),
            ...Array.from(new Set(item.voucherCashInfo.map(e => e.name)))
          ].join('&')}}
           {{item.balance ? (item.cash || item.card) ? ' & 點數' : '點數' : ''}}</div>
        </div>
        <!-- <div class="field" v-if="item.orderId&&item.payInfo">
          <div>付款編號</div>
          <div>{{item.orderId}}</div>
        </div> -->
        <template v-if="item.payInfo?.ECR_Response_Code">
          <hr>
          <div class="field">
            <div>卡號</div>
            <div>{{item.payInfo.Card_No}}</div>
          </div>
          <div class="field">
            <div>授權碼</div>
            <div>{{item.payInfo.Approval_No}}</div>
          </div>
          <div class="field" v-if="item.payInfo.Trans_Date">
            <div>授權時間</div>
            <div>{{moment(item.payInfo.Trans_Date+item.payInfo.Trans_Time, 'GGMMDDHHmmss').format('YYYY/MM/DD HH:mm:ss')}}</div>
          </div>
          <div class="field">
            <div>卡別</div>
            <div>{{getCreditType(item.payInfo.Card_Type)}}</div>
          </div>
          <hr>
        </template>
        <template v-if="item.payInfo?.Response_Code">
          <hr>
          <div class="field">
            <div>交易類型</div>
            <div>{{item.payInfo.Trans_Type === '11' ? '銷售' : '退貨'}}</div>
          </div>
          <div class="field" v-if="item.payInfo.Trans_Date">
            <div>授權時間</div>
            <div>{{moment(item.payInfo.Txn_Date+item.payInfo.Txn_Time, 'YYYYMMDDHHmmss').format('YYYY/MM/DD HH:mm:ss')}}</div>
          </div>
          <div class="field">
            <div>訂單編號</div>
            <div>{{item.payInfo.Order_Id}}</div>
          </div>
          <div class="field">
            <div>電子錢包</div>
            <div>{{getPayway(item.payInfo.Wallet)}}</div>
          </div>
          <hr>
        </template>
        <div class="field" v-if="item.payInfo">
          <div>支付金額</div>
          <div>{{formatDollarInt(parseInt(item.payInfo.Trans_Amount)/(item.payInfo?.ECR_Response_Code ? 100 : 1))}}</div>
        </div>
        <template v-if="item.cash">
          <div class="field">
            <div>現金</div>
            <div>{{item.cash}}</div>
          </div>
          <div class="field">
            <div>找零</div>
            <div>{{item.cashreturn}}</div>
          </div>
        </template>

        <div class="field" v-for="(vc, v) in item.voucherCashInfo" :key="`vc-${v}`">
          <div>{{vc.name}}</div>
          <div>{{vc.Trans_Amount}}</div>
        </div>
        <div class="field" v-if="item.balance">
          <div>點數折抵</div>
          <div>{{item.balance}}</div>
        </div>
      </SliderInfoBtnsT2>
    <SliderInfoBtnsT2  v-if="item" :title="'會員資訊'" :style="{height: 'fit-content'}" :btnHide="true">
    <div id="member">
      <div>{{item.memberID||'現場來客'}}</div>
      <div v-if="item.member">{{item.member?.name}} {{item.member?.mobile}}</div>
    </div>
    </SliderInfoBtnsT2>
    <SliderInfoBtnsT2  v-if="item" :title="'銷售數量'"
    :edit="editOrder" @edit="editOrder=true">
    <template  v-for="(itm, i) in item.Orders">
      <hr class="orders" v-if="i!==0" :key="`hr-${i}`">
      <OrderCard :key="`card-${i}`" :item="itm"/>
    </template>
    <hr>
    <div class="field3" :style="{}">
      <div>
        <div>折扣</div>
        <div>${{item.disc}}</div>
      </div>
      <div>
        <div>發票稅額</div>
        <div>${{(((item.price)*(5/105))).toFixed(0)}}</div>
      </div>
    </div>
    <div class="field3" :style="{}">
      <div></div>
      <div>
        <div>發票總額</div>
        <div>{{item.price}}</div>
      </div>
    </div>
    </SliderInfoBtnsT2>
    <SliderInfoBtnsT2  v-if="item&&((item.cps&&item.cps.length>0)||(item.tks&&item.tks.length>0))" :title="'票券'"
    :edit="editOrder" @edit="editOrder=true">
    <div class="cpstksGroup">
      <div class="tkscpstitle" v-if="item.tks&&item.tks.length>0">門票</div>
      <template  v-for="(itm, i) in item.tks">
        <div class="tkscps" :key="`tks-${i}`"><div>{{i+1}}. {{itm.name}}</div><div class="statuscps" :class="itm.status" :title="itm.redemptionTime?'兌換時間:'+toDateTime(itm.redemptionTime):''">{{itm.status}}</div></div>
      </template>
      <div class="tkscpstitle" v-if="item.cps&&item.cps.length>0">優惠券</div>
      <template  v-for="(itm, i) in item.cps">
        <div class="tkscps" :key="`cps-${i}`"><div>{{i+1}}. {{itm.couponName}}</div><div class="statuscps" :class="itm.status" :title="itm.redemptionTime?'兌換時間:'+toDateTime(itm.redemptionTime):''">{{itm.status}}</div></div>
      </template>
    </div>
    </SliderInfoBtnsT2>
    </template>
    </div>
  </Slider>
  <Dialog :show="TEXT" v-if="item" @close="TEXT=null" :label="'作廢發票'" :width="522">
    <div :style="{padding: '23px 48px 28px 36px'}">
      <div :style="{fontSize: '18px', fontWeight: 500, color: 'var(--color-checked)'}">發票號碼</div>
      <div :style="{fontSize: '40px', fontWeight: 500, color: 'var(--color-pri)'}">
        <div v-for="iv in item.inv" :key="`iv-${iv.InvoiceNo}`"
        :style="[iv.status === '作廢' ? {textDecoration: 'line-through'} : {}]">{{iv.InvoiceNo}}</div>
      </div>
      <div :style="{fontSize: '22px', color: 'var(--highlight)', letterSpacing: '1px'}">線上作廢發票請人工進行退款動作。</div>
      <div class="required" :style="{marginTop: '27px'}">請選擇作廢原因 (*必選)</div>
      <div class="flexCol" :style="{marginTop: '10px'}">
        <label :for="res.reasonID" v-for="(res, r) in Reasons"  :key="`Reason-${r}`">
          <input type="radio" :id="res.reasonID" :value="{Reason: res.reasonName, ReasonCode: res.reasonID}" v-model="Reason">{{res.reasonName}}
        </label>
      </div>
      <Btns @save="cancel" @cancel="TEXT=null" :style="{marginTop: '34px'}" :save="'確定'"/>
    </div>
  </Dialog>
  <Dialog :style="{position:'fixed'}" :show="cancelEc" v-if="cancelEc" label="綠界交易資訊" @close="cancelEc=null">
    <DialogEC :data="cancelEc.data" @close="cancelEc=null" @refund="refundEcPay()"/>
  </Dialog>
  <Dialog :style="{position:'fixed'}" :show="cancelLine" v-if="cancelLine" label="LINEPAY交易資訊" @close="cancelLine=null">
    <DialogLY :data="(cancelLine?.data || [])[0] || null" :error="cancelLine.codeMsg" @close="cancelLine=null" @refund="refundLinePay"/>
  </Dialog>
</div>
</template>

<script>
import { mapState } from 'vuex'
import Btns from '../../components/btn/btns.vue'
import Dialog from '../../components/dialognoPadding2.vue'
import SqrBtn from '../../components/btn/sqr40016.vue'
import OrderCard from './orderCard.vue'
import OrderCardInv from './orderCardInv.vue'
import Slider from '../../components/infoSlider_v2.vue'
import SliderInfoBtns from '../../components/boxs/sideInfo.vue'
import SliderInfoBtnsT2 from '../../components/boxs/sideInfoTitleBtnarea.vue'
import remitInfoVue from './box/remitInfo.vue'
import remitVue from './box/remit.vue'
import DialogLY from './dialog/lyinfo.vue'
import DialogEC from './dialog/ecinfo.vue'
import { getapi, postapi } from '../../store/fetch'
export default {
  props: ['item', 'projects', 'salesmans', 'Reasons'],
  components: {
    DialogLY,
    DialogEC,
    remitInfoVue,
    remitVue,
    SqrBtn,
    OrderCard,
    OrderCardInv,
    Slider,
    SliderInfoBtns,
    SliderInfoBtnsT2,
    Dialog,
    Btns
  },
  computed: {
    ...mapState({
      statusList: 'statusList'
    }),
    inv () {
      if (this.item) {
        return this.item.inv.find(e => e.InvoiceNo === this.InvoiceNo)
      } else {
        return {}
      }
    }
  },
  mounted () {
    const res = this.Reasons[0]
    this.Reason = { Reason: res.reasonName, ReasonCode: res.reasonID }
  },
  data () {
    return {
      page: '交易資訊',
      // Reasons: [
      //   '未開統一編號',
      //   '變更付款方式',
      //   '退換貨/變更品項',
      //   '退款'
      // ],
      cancelEc: null,
      cancelLine: null,
      Reason: '未開統一編號',
      edit: null,
      editRemark: false,
      editRemit: false,
      editOrder: false,
      RemarkEdit: null,
      editItem: {},
      agencyText: null,
      agenciesShort: [],
      agency: null,
      TEXT: null,
      InvoiceNo: null
    }
  },
  watch: {
    item: {
      deep: true,
      handler () {
        this.edit = null
        if (this.item) {
          this.InvoiceNo = this.item.inv.map(e => e.InvoiceNo)[0]
        }
      }
    },
    agencyText () {
      this.getagenciesShort()
    }
  },
  methods: {
    async refundLinePay () {
      const id = this.item._id
      const r = await postapi(`payment/linepay/refund/${id}`)
      if (r) {
        this.item.remitInfo = r.remitInfo
        this.item.status = r.status
        this.$emit('remitUpdate', r)
        this.cancelLine = null
      }
    },
    async refundEcPay () {
      const id = this.item._id
      const r = await postapi(`payment/ecpay/refund/${id}`)
      if (r) {
        this.item.remitInfo = r.remitInfo
        this.item.status = r.status
        this.$emit('remitUpdate', r)
        this.cancelEc = null
      }
    },
    removeAgency () {
      this.agency = null
    },
    async getagenciesShort () {
      if (this.agencyText) {
        this.agenciesShort = await getapi(`agencies/short?${new URLSearchParams({ search: this.agencyText })}`)
      } else {
        this.agenciesShort = []
      }
    },
    fnEdit () {
      const {
        recipient, recipientTel, address, level, agency, agencyID,
        orderer, ordererTel, visitDate, visitTime, type, orderType, project, status
      } = this.item
      this.agency = agency
      this.itemEdit = {
        orderer,
        ordererTel,
        recipient,
        recipientTel,
        address,
        agencyID,
        visitTime,
        type,
        orderType,
        project,
        level,
        status,
        visitDate: this.moment(visitDate).format('yyyy-MM-DD')
      }
      this.edit = 'info'
    },
    async cancel () {
      const body = { status: '已取消', ...this.Reason }
      if (this.item.payInfo && this.item.payInfo.ECR_Response_Code) {
        const CancelInfo = JSON.parse(JSON.stringify(this.item.payInfo))
        CancelInfo.Trans_Type = '30'
        delete CancelInfo.Trans_Date
        delete CancelInfo.Trans_Time
        body.CancelInfo = CancelInfo
      } else if (this.item.payInfo && this.item.payInfo.Response_Code) {
        const CancelInfo = JSON.parse(JSON.stringify(this.item.payInfo))
        CancelInfo.Trans_Type = '12'
        delete CancelInfo.Txn_Date
        delete CancelInfo.Txn_Time
        body.CancelInfo = CancelInfo
      }
      const r = await postapi(`restaurant${this.item.inv ? '/withInv' : ''}/${this.item._id}`, body)
      if (r) {
        this.TEXT = null
        this.Reason = null
        this.$emit('update', r)
      }
    },
    async saveRemit () {
      const params = { ...this.editItem }
      params.remitTime = this.moment(`${this.editItem.remitDate} ${this.editItem.remitTime}`).toISOString()
      const r = await postapi(`restaurant/${this.item._id}`, params)
      if (r) {
        this.edit = false
        this.$emit('update', r)
      }
    },
    async save () {
      const r = await postapi(`restaurant/${this.item._id}`, {
        ...this.itemEdit,
        visitDate: this.moment(this.itemEdit.visitDate).toISOString()
      })
      if (r) {
        this.edit = false
        this.$emit('update', r)
      }
    },
    async saveSalesman () {
      const r = await postapi(`restaurant/${this.item._id}`, {
        salesman: this.editItem.salesman
      })
      if (r) {
        this.edit = null
        this.$emit('update', r)
      }
    },
    async saveRemark () {
      const r = await postapi(`restaurant/${this.item._id}`, {
        remark: this.RemarkEdit
      })
      if (r) {
        this.edit = null
        this.$emit('update', r)
      }
    }
  }
}
</script>
<style lang="scss">
.editSheet {
  .slideBox_content {
    max-height: calc(100vh - 115px);
  }
}
</style>
<style lang="scss" scoped>
.cpstksGroup {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  &>div{
    width: 100%;
  }
}
.tkscpstitle {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: start;
  font-size: 22px;
  color: var(--color-pri);
  &:not(:nth-child(1)) {
    margin-top: 20px;
  }

}
.tkscps {
  font-size: 18px;
  letter-spacing: 1px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  .statuscps {
    padding: 4px 10px;
    &.兌換 {
      background-color: #FF8B8B;
      color: #FFFFFF;
      border-radius: 3px;
    }
    &.發送 {
      background-color: var(--color-checked);
      color: #FFFFFF;
      border-radius: 3px;
    }
    &.轉贈 {
      background-color: var(--point);
      color: #FFFFFF;
      border-radius: 3px;
    }

  }
}
.flexCol {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: flex-start;
  justify-content: flex-start;
  label {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
    padding: 10px 10px 10px 0px;
    font-family: Noto Sans TC;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 1.8px;
  }
  input[type=radio] {
    box-sizing: border-box;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    appearance: none;
    border-radius: 12px;
    border: 2px solid var(--color-pri);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &:checked {
      background-color: var(--color-checked);
    }
    &::before {
      box-sizing: border-box;
      content: '';
      display: inline-flex;
      margin: auto;
      background-color: #FFFFFF;
      width: 10px;
      height: 10px;
      // position: absolute;
      // top: 5px;
      // left: 5px;
      border-radius: 5px;
    }
  }
}
.required {
  font-size: 18px;
  color: var(--highlight);
  font-weight: 500;
  letter-spacing: 1.8px;
  text-align: start;
}
#member {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  &>div{
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    color: #787878;
    text-align: start;
  }
}
.highlight {
  font-weight: 700;
  color: #FF8B8B;
  font-size: inherit;

}
.saleman {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: #787878;
  text-align: start;
}
textarea.remark {
  width: 100%;
  height: 100%;
  min-height: 160px;
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: #5E5E5E;
}
.agency-box {
  display: flex;
  align-items: center;
  height: 40px;
  padding-inline: .75em;
  border: 1px solid #CACACA;
  border-radius: 3px;
  font-size: 18px;
  position: relative;
  width: 100%;
  z-index: 1;
  button {
    z-index: 2;
    position: absolute;
    top: 8.5px;
    right: 8.5px;
    background-color: transparent;
    width: 23px;
    height: 23px;
    padding: 0;
    &::before {
      content: '';
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: #CACACA;
      display: inline-flex;
      mask-image: url(../svg/btn/close.svg);
      mask-size: 15px;
      mask-repeat: no-repeat;
      mask-position: center center;
      border: none;
      outline: 1px solid #CACACA;
      box-sizing: content-box;
    }
    &:hover {
      background-color: #CACACA;
      &::before {
        background-color: #FFFFFF;
      }
    }
  }
}
.ul {
  position: absolute;
  right: 0;
  width: 350px;
  background-color: #FFFFFF;
  max-height: 230px;
  overflow-y: auto;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  z-index: 99;
  .li {
    padding-block: 7.25px;
    padding-inline: .75em;
    min-height: 55px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    line-height: 40px;
    &:hover {
      background-color: #CACACA;
    }
  }
}
.viplevel {
  background-repeat: no-repeat;
  &.viplevel-1 {
    width: 27px;
    height: 26px;
    background-image: url(..//svg/icon/level1.svg);
  }
  &.viplevel-2 {
    width: 30px;
    height: 25px;
    background-image: url(..//svg/icon/level2.svg);
  }
  &.viplevel-3 {
    width: 30px;
    height: 22px;
    background-image: url(..//svg/icon/level3.svg);
  }
}
p {
  text-align: start;
  font-size: 20px;
  line-height: 29px;
}
.field3 {
  display: grid;
  grid-template-columns: 1fr 1.3fr;
  gap: 80px;
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  color: #787878;
  &>div{
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #787878;
    display: grid;
    grid-template-columns: repeat(2,  1fr);
    &>div:nth-child(1) {
      text-align: start;
    }
    &>div:nth-child(2) {
      text-align: end;
    }
  }
}
.field2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  color: #999999;
  &>div:nth-child(1) {
    text-align: start;
  }
  &>div:nth-child(2) {
    text-align: end;
  }
}
.field-edit {
  &>div:nth-child(1) {
    line-height: 40px;
  }
  input[type=text], textarea {
    width: 220px;
    height: 40px;
    border: 1px solid #CACACA;
    border-radius: 3px;
    padding-inline: .75em;
    box-sizing: border-box;
    font-size: 18px;
    color: #5E5E5E;
  }
  textarea {
    padding-block: .5em;
    width: 100%;
  }
}
.field {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;
  gap: 10px;
  &>div{
    font-weight: 400;
    font-size: 20px;
    text-align: start;
    letter-spacing: 0.1em;
    min-width: 100px;
  }
  &>div:nth-child(1) {
    display: inline-block;
    width: 100px;
    color: #5E5E5E;
  }
}
hr {
  width: 100%;
  border: none;
  height: 1px;
  background-color:#CACACA;
  margin-inline: auto;
  margin-block: 10px;
}
hr.orders {
  border-inline: 6px solid var(--color-pri);
  background-color: var(--color-pri);
  border-block: 4px solid #FFFFFF;
  height: 10px;
}
.flexH {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px;
  overflow-y: auto;
  max-height: calc(100%);
  &>div{
    min-height: fit-content;
  }
}
</style>
